"use client";

import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";

export function ReadUnavailable() {
	const router = useRouter();
	const t = useTranslations("common");
	const cartT = useTranslations("cart");
	return (
		<section
			role="status"
			className="mx-auto max-w-2xl space-y-4 rounded-xl border border-border bg-card p-6 text-center"
		>
			<p className="text-muted-foreground">{t("error")}</p>
			<button
				type="button"
				onClick={() => router.refresh()}
				className="hover:bg-primary/90 min-h-11 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground focus-visible:ring-2 focus-visible:ring-ring"
			>
				{cartT("retryAdd")}
			</button>
		</section>
	);
}
